import { FolderTreeNode } from '@seahorse/ui';

export function buildFolderTreeFromPaths(paths: string[]): FolderTreeNode[] {
  const root: FolderTreeNode = { path: '', name: 'Root', subFolders: [] };
  const pathMap = { '': root };

  paths.forEach((fullPath) => {
    const parts = fullPath.split('/');
    let currentPath = '';
    let parent = root;

    parts.forEach((part) => {
      if (!part) return;
      currentPath += (currentPath ? '/' : '') + part;
      if (!pathMap[currentPath]) {
        const node: FolderTreeNode = {
          path: currentPath,
          name: part,
          subFolders: [],
        };
        pathMap[currentPath] = node;
        parent.subFolders.push(node);
      }
      parent = pathMap[currentPath];
    });
  });

  return root.subFolders;
}
